<script>
import Icon from "./Icon.vue";

export default {
  name: 'DropdownMenuButton',
  components: {Icon},

  props: {

    // Icon prop - follows same naming as icon.vue, any svg in the icons folder will work
    icon: {
      type: String,
      default: "bars"
    }
  },

  emits: ['menu-click'],
  data() {
    return {
      isMenuOpen: false
    };
  },

  mounted() {
    document.addEventListener('keydown', this.handleEscape);
    document.addEventListener('click', this.screenClick);

  },

  unmounted() {
    document.removeEventListener('keydown', this.handleEscape);
    document.removeEventListener('click', this.screenClick);

  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    closeMenu() {
      this.isMenuOpen = false;
    },

    handleEscape(e) {
      if (e.key === 'Escape' && this.isMenuOpen) {
        this.closeMenu();
      }
    },
    screenClick(event) {
      // Close the menu if the user clicks anywhere else on the screen
      if (this.$refs.menuContainer && !this.$refs.menuContainer.$el.contains(event.target)) {
        this.closeMenu();
      }
    }
  }
};
</script>

<template>
  <div
    ref="menu-container"
    class="menu-container"
  >
    <div class="menu">
      <button
        class="hamburger-btn"
        :class="{ 'active': isMenuOpen }"
        aria-label="Toggle menu"
        @click="toggleMenu"
      >
        <icon
          size="24px"
          :icon="icon"
        />
      </button>

      <!-- Dropdown Menu -->
      <div
        class="dropdown-menu"
        :class="{ 'show': isMenuOpen }"
      >
        <div class="nav-menu">
          <slot name="nav-menu-items" />
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>

/* Logo Section */
.logo-container {
  @apply flex items-center;

  &.collapsed {
    width: 60px;
  }

  &.expanded {
    @apply w-64;
    @apply pl-8;
  }
}

/* Menu Section */
.menu-container {
  @apply relative;
}

/* Dropdown Menu */
.dropdown-menu {
  @apply absolute right-0 bg-white border border-gray-200 rounded-lg shadow-lg min-w-[160px];
  @apply transition-all duration-300 ease-in-out overflow-hidden;
  @apply invisible opacity-0;
  transform: translateY(-10px);
  z-index: 1000;
}

.dropdown-menu.show {
  @apply opacity-100 visible;
  transform: translateY(0);
}

.nav-menu {
  @apply flex flex-col;
}

.nav-item, :deep(.nav-item) {
  @apply p-4 text-gray-700 no-underline text-sm transition-colors duration-200 ease-in-out cursor-pointer;

  &:hover {
    @apply bg-gray-50 text-gray-900;
  }
  &:focus {
    @apply outline-2 outline-blue-500 outline-offset-[-2px] bg-gray-50;
  }
}

/* Mobile Overlay */


.menu-overlay.show {
  @apply opacity-100 visible;
}


</style>
